import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { useSelectedProjectStore } from '@/components/entities/common/model/selected-project.store'

import { CountersService } from '../lib/counters.service'

export const COUNTERS_RESOURCES_RQ_KEY = 'counters-resources'

export const useCountersResources = () => {
  const { selectedProjectId } = useSelectedProjectStore()

  const { data, isLoading, error } = useQuery({
    queryKey: [COUNTERS_RESOURCES_RQ_KEY, selectedProjectId],
    queryFn: () => CountersService.getCountersResources(selectedProjectId),
    placeholderData: keepPreviousData
  })

  return {
    data,
    isLoading,
    error
  }
}
